import React from "react";
import { SvgIcon } from "@mui/material";

const POSIcon = ({ fill }) => {
  return (
    <>
      <SvgIcon>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill={fill}
          />
          <path
            d="M6.5 14H8.5C8.78 14 9 13.78 9 13.5V11.5C9 11.22 8.78 11 8.5 11H6.5C6.22 11 6 11.22 6 11.5V13.5C6 13.78 6.22 14 6.5 14Z"
            fill={fill}
          />
          <path
            d="M11 14H13C13.28 14 13.5 13.78 13.5 13.5V11.5C13.5 11.22 13.28 11 13 11H11C10.72 11 10.5 11.22 10.5 11.5V13.5C10.5 13.78 10.72 14 11 14Z"
            fill={fill}
          />
          <path
            d="M15.5 14H17.5C17.78 14 18 13.78 18 13.5V11.5C18 11.22 17.78 11 17.5 11H15.5C15.22 11 15 11.22 15 11.5V13.5C15 13.78 15.22 14 15.5 14Z"
            fill={fill}
          />
          <path
            d="M6 9H18C18.55 9 19 8.55 19 8C19 7.45 18.55 7 18 7H6C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9Z"
            fill={fill}
          />
          <path
            d="M11 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H11C10.45 15 10 15.45 10 16C10 16.55 10.45 17 11 17Z"
            fill={fill}
          />
        </svg>
      </SvgIcon>
    </>
  );
};

export default POSIcon;
